"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../../../IconicDisplayElements/Icon"));

var _displayModes = require("../../../../constants/displayModes");

var _Common = require("./Common.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditButtons = _react.default.memo(function (_ref) {
  var disabled = _ref.disabled,
      errors = _ref.errors,
      mode = _ref.mode,
      toggleEditMode = _ref.toggleEditMode;

  if (mode === _displayModes.displayModes.viewing && !disabled) {
    return /*#__PURE__*/_react.default.createElement(_Common.StyledLinkButton, {
      dataTestId: "input-edit-link-button",
      isBlock: true,
      onClick: toggleEditMode
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      dataTestId: "input-edit-icon",
      iconName: "pencil-alt",
      colorTheme: "primary"
    }));
  }

  if (mode === _displayModes.displayModes.editing && !disabled && !errors.length) {
    return /*#__PURE__*/_react.default.createElement(_Common.StyledLinkButton, {
      dataTestId: "input-edit-link-button",
      isBlock: true,
      onClick: toggleEditMode
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      dataTestId: "input-edit-icon",
      iconName: "check-circle",
      colorTheme: "primary"
    }));
  }

  return null;
});

EditButtons.propTypes = {
  /** Flag used to disable the input */
  disabled: _propTypes.default.bool,

  /** Flag used for indicating an error state for the input */
  errors: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),

  /** Mode flag
   * - 'editOnly' for single mode, editable
   * - 'viewing' for dual mode, starting in a 'viewing' state
   * - 'viewOnly' for single mode, not editable
   */
  mode: _propTypes.default.oneOf([undefined, _displayModes.displayModes.editing, _displayModes.displayModes.editOnly, _displayModes.displayModes.viewing, _displayModes.displayModes.viewOnly]),

  /** Callback to trigger when button has been activated */
  toggleEditMode: _propTypes.default.func.isRequired
};
EditButtons.defaultProps = {
  disabled: false,
  errors: [],
  mode: _displayModes.displayModes.editOnly
};
var _default = EditButtons;
exports.default = _default;